<script lang="js">
import { mapGetters } from "vuex";
import AppNavbar from "@/components/base/AppNavbar.vue";
import AppSidebar from "@/components/base/AppSidebar.vue";


export default {
  data() {
    return {
      isDevelopment: process.env.NODE_ENV === "development",
    };
  },
  methods: {},
  computed: {
    ...mapGetters(["getUser", "getApplication", "getStudent"]),
    user() {
      return this.getUser || {};
    },
    userData() {
      return { ...this.user, ...(this.getApplication || {}), ...(this.getStudent || {}) };
    },
    hideAppHeader() {
      return this.$route.meta.hideAppHeader || false;
    },
    hideAppSidebar() {
      return this.$route.meta.hideAppSidebar || false;
    },
    menuItems() {
      // Use different routes for development vs production
      if (this.isDevelopment) {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/app" },
          { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/app/academics" },
          { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/app/resources" },
          { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/app/finance" }
        ];
      } else {
        return [
          { name: "Dashboard", label: "Dashboard", icon: "bi bi-columns-gap", route: "/dashboard" },
          { name: "Academics", label: "Academics", icon: "bi bi-mortarboard-fill", route: "/academics" },
          { name: "Resources", label: "Resources", icon: "bi bi-folder-fill", route: "/resources" },
          { name: "Finance", label: "Finance", icon: "bi bi-credit-card", route: "/finance" }
        ];
      }
    },
  },
  components: { AppNavbar, AppSidebar },
};
</script>

<template>
  <div class="container-fluid p-0 vh-100">
    <div class="vh-100 d-flex flex-column">
      <!-- Top Navbar -->
      <AppNavbar v-if="!hideAppHeader"></AppNavbar>

      <!-- Main Layout (Sidebar + Content) -->
      <div
        class="d-flex flex-grow-1"
        :style="{
          paddingTop: hideAppHeader ? '0' : '56px',
        }"
      >
        <!-- Fixed Sidebar -->
        <AppSidebar v-if="!hideAppSidebar"></AppSidebar>

        <!-- Main Content (Scrollable) -->
        <div
          class="flex-grow-1 overflow-auto"
          :style="{
            'background-color': '#f4f4f4',
            'margin-left': hideAppSidebar ? '0' : '0px',
            width: hideAppSidebar ? '100%' : 'calc(100% - 140px)',
          }"
        >
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
